import { render, staticRenderFns } from "./empowerMsg.vue?vue&type=template&id=0842c648&scoped=true"
import script from "./empowerMsg.vue?vue&type=script&lang=js"
export * from "./empowerMsg.vue?vue&type=script&lang=js"
import style0 from "./empowerMsg.vue?vue&type=style&index=0&id=0842c648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0842c648",
  null
  
)

export default component.exports